"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
const styles_1 = require("@material-ui/core/styles");
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const prop_types_1 = __importDefault(require("prop-types"));
const totangoTheme_1 = require("../../theme/totangoTheme");
const alert_message_1 = __importStar(require("../alert-message/alert-message"));
const useCharCount_1 = __importDefault(require("../character-count-text-input/useCharCount"));
const Input = (props) => {
    const { startAdornment, helperText, startAdornmentProps, endAdornment, maxLength, hideAlertIcon, InputProps, inputProps, value, disabled, multiline, onChange, countChars, error, errorType, max, pattern, rows, ...restProps } = props;
    const shouldCountChars = countChars && maxLength > 0;
    const { handleChange, component } = (0, useCharCount_1.default)({
        shouldCountChars,
        onChange,
        maxLength,
        value,
        multiline,
        pattern,
    });
    const inputPropsValues = (0, react_1.useMemo)(() => {
        const inputValues = {
            inputProps: { ...inputProps, maxLength, max },
            ...InputProps,
        };
        if (startAdornment) {
            inputValues.startAdornment = (react_1.default.createElement(InputAdornment_1.default, { position: "start", ...startAdornmentProps }, startAdornment));
        }
        if (endAdornment) {
            inputValues.endAdornment = react_1.default.createElement(InputAdornment_1.default, { position: "end" }, endAdornment);
        }
        if (shouldCountChars) {
            inputValues.endAdornment = component;
        }
        return inputValues;
    }, [
        InputProps,
        component,
        endAdornment,
        inputProps,
        maxLength,
        shouldCountChars,
        startAdornment,
        startAdornmentProps,
        max,
    ]);
    return (react_1.default.createElement(styles_1.MuiThemeProvider, { theme: totangoTheme_1.totangoTheme },
        react_1.default.createElement(TextField_1.default, { InputProps: inputPropsValues, helperText: (error || errorType) && helperText && !hideAlertIcon ? (react_1.default.createElement(alert_message_1.default, { level: errorType || alert_message_1.ALERT_LEVELS.error, text: helperText, bordered: false })) : (helperText), disabled: disabled, error: error, onChange: handleChange, multiline: multiline, value: value, minRows: rows, ...restProps })));
};
Input.defaultProps = {
    value: '',
    placeholder: '',
    label: '',
    className: '',
    errorType: '',
    inputProps: {},
    InputProps: {},
    countChars: false,
    startAdornmentProps: {},
    helperText: '',
    hideAlertIcon: false,
    pattern: undefined,
    maxLength: undefined,
    inputRef: undefined,
    onChange: undefined,
    multiline: false,
    error: false,
};
Input.propTypes = {
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    inputRef: prop_types_1.default.oneOfType([
        prop_types_1.default.func,
        // an instance of a DOM native element
        prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(Element) }),
    ]),
    hideAlertIcon: prop_types_1.default.bool,
    helperText: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    errorType: prop_types_1.default.string,
    error: prop_types_1.default.bool,
    placeholder: prop_types_1.default.string,
    className: prop_types_1.default.string,
    label: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
    inputProps: prop_types_1.default.object,
    InputProps: prop_types_1.default.object,
    countChars: prop_types_1.default.bool,
    startAdornmentProps: prop_types_1.default.object,
    pattern: prop_types_1.default.instanceOf(RegExp),
    maxLength: prop_types_1.default.number,
    multiline: prop_types_1.default.bool,
};
exports.default = Input;
//# sourceMappingURL=input.js.map